module.exports = __webpack_public_path__ + "static/media/September2022Newsletter.3ca005ba.pdf";